import { render, staticRenderFns } from "./Shopware.vue?vue&type=template&id=39bc190f&"
import script from "./Shopware.vue?vue&type=script&lang=js&"
export * from "./Shopware.vue?vue&type=script&lang=js&"
import style0 from "./Shopware.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports